import { useErrorNotificationApi } from '../useErrorNotificationApi';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

type LenderType = 'secured' | 'unsecured';

export type SupplierCode = number;
export type SupplierName = string;

export type Lender = {
  supplierCode: SupplierCode,
  name: SupplierName
}

export function useLendersApi() {
  const { get } = useErrorNotificationApi(apiUrl);

  return {
    getLenders: (lenderType: LenderType): Promise<Lender[]> => get(`searches/static/${lenderType}-lenders`),
  };
}
